import GlobalStyles from "@mui/material/GlobalStyles";
import { LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT } from "@portal/app/_components/ui-elements/layoutBreakpoints";

const mobileHeight = "56px";
const mainVerticalHeight = "0.25rem";
export const GlobalStyle = ({ $isPagesDirectory }: { $isPagesDirectory?: boolean }) => (
  <GlobalStyles
    styles={(theme) => ({
      ":root": {
        "--font-serif": '"Source Serif Pro", Georgia, Times, serif',
        "--font-mono":
          'Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace',
        "--horizontal-padding": "40px",
        "--horizontal-inset-space": "5px",
        "--horizontal-maxWidth": "820px",
        "--vh": "1rem",
        "--font-sans": $isPagesDirectory ? '"Public Sans", -apple-system, sans-serif' : undefined,

        /* Shared variables */
        "--NavBarDesktopHeight": "72px",
        "--NavBarDesktopMainVerticalMargin": mainVerticalHeight,
        "--NavBarMobileHeight": mobileHeight,
        "--NavBarMobileMainVerticalMargin": mainVerticalHeight,
        "--NavBarHeight": "var(--NavBarDesktopHeight)",
        "--NavBarMainVerticalMargin": mainVerticalHeight,

        [theme.breakpoints.down(LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT)]: {
          "--NavBarHeight": mobileHeight,
          "--NavBarMainVerticalMargin": mainVerticalHeight,
        },
      },
      "html, body, #__next, *, *:before, *:after": {
        boxSizing: "border-box",
      },
      html: {
        fontSize: "16px",
        height: "100%",
      },
      body: {
        fontFamily: "var(--font-sans)",
        lineHeight: "1.45",
        height: "100%",
        margin: 0,
      },
      "#__next": {
        height: "100%",
      },
      "button, input, select, textarea": {
        fontFamily: "var(--font-sans)",
        lineHeight: "1.45",
      },
      "menu, ol, ul": {
        padding: "inherit",
        listStyle: "inherit",
      },
      strong: {
        fontWeight: 700,
      },
      em: {
        fontStyle: "italic",
      },
      a: {
        color: "#04299E",
      },
      code: {
        fontFamily: "var(--font-mono)",
      },
      hr: {
        margin: "1rem 0",
        border: "none",
        borderTop: "1px dotted rgba(0, 0, 0, 0.2)",
      },
      "@media (min-width: 1100px)": {
        ":root": {
          "--vh": "calc(75px - 0.11 * (1600px - 100vw))",
        },
      },
      "@media (min-width: 1600px)": {
        ":root": {
          "--vh": "calc(50vw - 725px)",
        },
      },
      "@media (max-width: 1100px)": {
        ":root": {
          "--horizontal-padding": "30px",
          "--horizontal-maxWidth": "800px",
        },
      },
      "@media (max-width: 420px)": {
        ":root": {
          "--horizontal-inset-space": "0px",
          "--horizontal-padding": "20px",
        },
        html: {
          fontSize: "14px",
        },
      },
      "@media (max-width: 330px)": {
        ":root": {
          "--horizontal-padding": "15px",
        },
        html: {
          fontSize: "13px",
        },
      },
      ".pac-container": {
        /**
         * This class is used by the Google Maps autocomplete suggestions.
         * By default, MuiDialog uses 1300, and .pac-container uses 1000...
         */
        zIndex: "2000 !important",
      },
    })}
  />
);
